import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { SkipToMainComponent } from './skip-to-main.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, TranslateModule],
  declarations: [SkipToMainComponent],
  exports: [SkipToMainComponent]
})
export class SkipToMainModule {}
